import { DB } from "../lib/deviceStorage";
import { shadowKey } from "../lib/syncUtils";
import { APP_VERSION } from "../config/appConfig";

// v2.242.06: limpar live cache ao detectar mudança de versão.
// window.__fzLiveCollections pode conter dados sujos de versões anteriores se a aba
// não foi recarregada após um update do service worker. Como readLatestCollectionState
// prefere o live cache, dados sujos causam divergência permanente e loop de 429.
// sessionStorage é limpo ao fechar/reabrir o app/aba; a limpeza é segura porque o
// cache é reconstruído na próxima leitura/sync.
const LIVE_CACHE_VERSION_KEY = "fz:liveCacheVersion";
try {
  const cachedVersion = sessionStorage.getItem(LIVE_CACHE_VERSION_KEY) || "";
  const currentVersion = String(APP_VERSION || "");
  if (currentVersion && cachedVersion !== currentVersion) {
    if (typeof window !== "undefined") {
      window.__fzLiveCollections = {};
    }
    sessionStorage.setItem(LIVE_CACHE_VERSION_KEY, currentVersion);
  }
} catch (_) {}


function getLiveCollectionCache(key) {
  try {
    return window.__fzLiveCollections?.[key];
  } catch(e) {
    return undefined;
  }
}

function setLiveCollectionCache(key, value) {
  try {
    window.__fzLiveCollections = window.__fzLiveCollections || {};
    window.__fzLiveCollections[key] = Array.isArray(value) ? value : (value ?? []);
  } catch(e) {}
}

async function readLatestCollectionState(farmId, collection) {
  const localKey = `fz:${farmId}:${collection}`;
  const shadowK = shadowKey(farmId, collection);
  const liveLocal = getLiveCollectionCache(localKey);
  const liveShadow = getLiveCollectionCache(shadowK);
  const locData = liveLocal !== undefined ? liveLocal : ((await DB.get(localKey)) || []);
  const baseRaw = liveShadow !== undefined ? liveShadow : (((await DB.get(shadowK)) || []));
  return { localKey, shadowK, locData, baseRaw };
}

export { getLiveCollectionCache, setLiveCollectionCache, readLatestCollectionState };
